'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardText = require('./ContentCardText.css');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SMALL_CARD_CHARACTER_CAP = 60;
var LARGE_CARD_CHARACTER_CAP = 120;

var ContentCardText = function (_React$Component) {
  _inherits(ContentCardText, _React$Component);

  function ContentCardText(props) {
    _classCallCheck(this, ContentCardText);

    var _this = _possibleConstructorReturn(this, (ContentCardText.__proto__ || Object.getPrototypeOf(ContentCardText)).call(this, props));

    _this.state = {
      hasPlayed: false
    };
    return _this;
  }

  _createClass(ContentCardText, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.videoPlaying && !this.state.hasPlayed) {
        this.setState({
          hasPlayed: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLarge = _props.isLarge,
          isImageCard = _props.isImageCard,
          caption = _props.caption,
          styleOverrides = _props.styleOverrides;
      var hasPlayed = this.state.hasPlayed;

      var text = this.props.text;

      if (text && text.length > LARGE_CARD_CHARACTER_CAP && isLarge) {
        text = text.substring(0, LARGE_CARD_CHARACTER_CAP) + '...';
      } else if (text && text.length > SMALL_CARD_CHARACTER_CAP && !isLarge) {
        text = text.substring(0, SMALL_CARD_CHARACTER_CAP) + '...';
      }

      return _react2.default.createElement(
        'div',
        { style: styleOverrides ? styleOverrides.contentCardTextStyles : null, className: 'jsx-' + _ContentCardText2.default.__scopedHash + ' ' + ('container ' + (isLarge ? 'isLarge' : '') + ' ' + (hasPlayed ? 'expanded' : ''))
        },
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _ContentCardText2.default.__scopedHash + ' ' + ((isImageCard && !hasPlayed ? 'isImageCard' : 'isTextCard') || '')
          },
          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: text }, className: 'jsx-' + _ContentCardText2.default.__scopedHash + ' ' + 'title'
          }),
          caption && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: caption }, className: 'jsx-' + _ContentCardText2.default.__scopedHash + ' ' + 'caption'
          })
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardText2.default.__scopedHash,
          css: _ContentCardText2.default.__scoped
        })
      );
    }
  }]);

  return ContentCardText;
}(_react2.default.Component);

ContentCardText.propTypes = {
  videoPlaying: _propTypes2.default.bool,
  text: _propTypes2.default.string.isRequired,
  isLarge: _propTypes2.default.bool,
  isImageCard: _propTypes2.default.bool,
  caption: _propTypes2.default.string,
  styleOverrides: _propTypes2.default.shape({
    contentCardTextStyles: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
  })
};

ContentCardText.defaultProps = {
  videoPlaying: false,
  isLarge: false,
  isImageCard: true,
  caption: null,
  styleOverrides: null
};

ContentCardText.displayName = 'ContentCardText';

exports.default = ContentCardText;